export default [
    {
        path: 'sales-slab-report',
        meta: { 
            label: 'Sales Slab Report', 
            permission: 'show_reports_sales_slab',
            icon: 'sales-slab',
            group: 'Order Reports'
        },
        name: 'sales-slab-report',
        component: () => import('./../../views/orderReport/SalesSlabReport.vue'),
    },
    {
        path: 'order-dashboard',
        meta: { 
            label: 'Order Dashboard', 
            permission: 'show_reports_order_dashboard',
            icon: 'dashboard',
            group: 'Order Reports'
        },
        name: 'order-dashboard',
        component: () => import('./../../views/orderReport/OrderDashboard.vue'),
    },
    {
        path: 'order-By-Type',
        meta: { 
            label: 'Order Report By Type', 
            permission: 'show_reports_order_by_type',
            icon: 'type',
            group: 'Order Reports'
        },
        name: 'order-By-Type',
        component: () => import('./../../views/orderReport/OrderStatisticsReport.vue'),
    },
    {
        path: 'order-statistics',
        meta: { 
            label: 'Order Statistics Report', 
            permission: 'show_reports_order_statistics',
            icon: 'statistics',
            group: 'Order Reports'
        },
        name: 'order-statistics',
        component: () => import('./../../views/orderReport/OrderSummaryReport.vue'),
    }
    , {
        path: 'order-details',
        meta: { 
            label: 'Order Details Report', 
            permission: 'show_reports_order_details',
            icon: 'details',
            group: 'Order Reports'
        },
        name: 'order-details',
        component: () => import('./../../views/orderReport/OrdersCollections.vue'),
    },
    {
        path: 'order-Supply-Chain-Report',
        meta: { 
            label: 'Order Supply Chain Report', 
            permission: 'show_reports_order_supply_chain',
            icon: 'supply-chain',
            group: 'Order Reports'
        },
        name: 'order-Supply-Chain-Report',
        component: () => import('./../../views/orderReport/SupplyChainReport.vue'),
    },
    {
        path: 'order-Finance-Supply-Chain-Report',
        meta: { 
            label: 'Order Finance Supply Chain Report', 
            permission: 'show_reports_order_supply_chain',
            icon: 'finance-supply-chain',
            group: 'Order Reports'
        },
        name: 'order-Finance-Supply-Chain-Report',
        component: () => import('./../../views/orderReport/FinanceSupplyChainReport.vue'),
    }
];